/* BackupSummaryComponent.js */

"use strict";

const {EventEmitter} = require("events");
const Renderer = require("./BackupSummaryRenderer");

class BackupSummaryComponent extends EventEmitter {
    constructor(backupResults, logger) {
        super();
        this._logger = logger;
        this._backupResults = backupResults;
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }

    _registerListeners() {
        // Add your event listener registrations here if needed.
    }

    _unregisterListeners() {
        // Add your event listener unregistrations here if needed.
    }

    get renderer() {
        return this._renderer;
    }

    get logger() {
        return this._logger;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer
            .shutdown()
            .then(() => {
                this._logger = undefined;
                this._renderer = undefined;
            })
            .catch((err) => {
                this._logger.warn({error: err}, "backupSummaryComponent.shutdown() error.");
            });
    }

    sendOk() {
        this._context.resolve({});
    }

    set "$teve.ui.context"(context) {
        //jshint ignore:line
        this._context = context;
    }

    getBackupResults() {
        return this._backupResults;
    }

    get backupResults() {
        return this.getBackupResults();
    }
}

module.exports = BackupSummaryComponent;
